import { supabasePublic } from "@/integrations/supabase/publicClient";
import type { Json } from "@/integrations/supabase/types";

export async function logEntryAttempt(input: {
  contestId: string;
  email: string;
  payload: Record<string, unknown>;
  error: string;
}): Promise<void> {
  const email = input.email.trim().toLowerCase();
  if (!input.contestId || !hasAttemptData(email, input.payload)) return;

  const { error } = await supabasePublic.from("entry_attempts").insert({
    contest_id: input.contestId,
    email: email || null,
    payload: input.payload as Json,
    error: input.error.slice(0, 500),
  });

  if (error) {
    console.error("Failed to save incomplete entry", error);
  }
}

function hasAttemptData(email: string, payload: Record<string, unknown>): boolean {
  if (email) return true;
  return Object.entries(payload).some(([key, value]) => {
    if (key === "email_opt_in" || key === "sms_opt_in") return value === true;
    if (value && typeof value === "object") {
      return Object.values(value as Record<string, unknown>).some((item) => String(item ?? "").trim());
    }
    return String(value ?? "").trim() !== "";
  });
}
